/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../graphql.generated'

const defaultOptions = {} as const
export type ShiftPatientProgramStartDateMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  days: Types.Scalars['Int']['input']
  isPostProgram: Types.Scalars['Boolean']['input']
}>

export type ShiftPatientProgramStartDateMutation = {
  __typename?: 'Mutation'
  shiftPatientProgramStartDate: {
    __typename?: 'Patient'
    uid: string
    enrollment: { __typename?: 'Enrollment'; programStartDate?: Date | null }
  }
}

export const ShiftPatientProgramStartDateDocument = gql`
  mutation ShiftPatientProgramStartDate($uid: ID!, $days: Int!, $isPostProgram: Boolean!) {
    shiftPatientProgramStartDate(uid: $uid, days: $days, isPostProgram: $isPostProgram) {
      uid
      enrollment {
        programStartDate
      }
    }
  }
`
export type ShiftPatientProgramStartDateMutationFn = Apollo.MutationFunction<
  ShiftPatientProgramStartDateMutation,
  ShiftPatientProgramStartDateMutationVariables
>

/**
 * __useShiftPatientProgramStartDateMutation__
 *
 * To run a mutation, you first call `useShiftPatientProgramStartDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShiftPatientProgramStartDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shiftPatientProgramStartDateMutation, { data, loading, error }] = useShiftPatientProgramStartDateMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      days: // value for 'days'
 *      isPostProgram: // value for 'isPostProgram'
 *   },
 * });
 */
export function useShiftPatientProgramStartDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShiftPatientProgramStartDateMutation,
    ShiftPatientProgramStartDateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ShiftPatientProgramStartDateMutation, ShiftPatientProgramStartDateMutationVariables>(
    ShiftPatientProgramStartDateDocument,
    options
  )
}
export type ShiftPatientProgramStartDateMutationHookResult = ReturnType<typeof useShiftPatientProgramStartDateMutation>
export type ShiftPatientProgramStartDateMutationResult = Apollo.MutationResult<ShiftPatientProgramStartDateMutation>
export type ShiftPatientProgramStartDateMutationOptions = Apollo.BaseMutationOptions<
  ShiftPatientProgramStartDateMutation,
  ShiftPatientProgramStartDateMutationVariables
>
